<template>
  <div class="pa-2">
    <v-row
      style="max-height: 150px; overflow: hidden; min-height: 150px; max-width: 1000px"
    >
      <div
        class="content"
        v-html="value.content"
      />
    </v-row>
    <v-row>
      <v-chip
        small
        outlined
        color="primary"
        class="ma-1"
      >
        <span
          class="grey--text text--darken-2"
        ><v-icon
          small
          color="grey-darken-2"
        >mdi-file-document-outline</v-icon>&nbsp;Версія:&nbsp;</span><span class="font-weight-bold grey--text text--darken-2">{{
          value.version
        }}</span>
      </v-chip>
      <v-chip
        small
        outlined
        color="primary"
        class="ma-1"
      >
        <span
          class="grey--text text--darken-2"
        ><v-icon
          small
          color="grey-darken-2"
        >today</v-icon>&nbsp;Створено:&nbsp;</span>
        <span class="font-weight-bold grey--text text--darken-2">{{
          value.author ? value.author.title : ""
        }}</span>&nbsp;<span
          class="font-weight-bold grey--text text--darken-2"
          style="text-decoration: underline;"
        >{{ value.date | dateTime }}</span>
      </v-chip>
      <v-chip
        v-if="value.updater || value.updateDate"
        small
        outlined
        color="primary"
        class="ma-1"
      >
        <span
          class="grey--text text--darken-2"
        ><v-icon
          small
          color="grey-darken-2"
        >edit_calendar</v-icon>&nbsp;Змінено:&nbsp;</span><span
          class="font-weight-bold grey--text text--darken-2"
        >{{ value.updater.title }}&nbsp; </span><span
          class="font-weight-bold grey--text text--darken-2"
          style="text-decoration: underline;"
        >{{ value.updateDate | dateTime }}</span>
      </v-chip>
    </v-row>
  </div>
</template>

<script>
export default {
  props: ["value"],
};
</script>
<style>
.content img {
  width: 50%;
}
</style>
